import { FooterMain, FooterName } from "./footer.styles";

const Footer = () => {
  return (
    <>
      <FooterMain>
        Made By
        <FooterName href="https://github.com/webdevtut">
          Tushar Kadam
        </FooterName>
        with ♥
      </FooterMain>
    </>
  );
};

export default Footer;
